export default __webpack_public_path__ + "static/media/python-r-bg.c63b417d.png";